import { render, staticRenderFns } from "./CardAdminCoordinadores.vue?vue&type=template&id=8eb184f6&scoped=true"
import script from "./CardAdminCoordinadores.vue?vue&type=script&lang=js"
export * from "./CardAdminCoordinadores.vue?vue&type=script&lang=js"
import style0 from "./CardAdminCoordinadores.vue?vue&type=style&index=0&id=8eb184f6&prod&scoped=true&lang=css"
import style1 from "../../assets/styles/personal-admin.css?vue&type=style&index=1&id=8eb184f6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb184f6",
  null
  
)

export default component.exports